/**
 * Calculates the yield curve based on the given spend and revenue coordinates.
 * @param curveCoordinates An array of tuples representing [spend, revenue].
 * @returns An array of tuples representing [spend, marginalYield].
 */
export const calculateYieldCurve = (curveCoordinates: [number, number][]): [number, number][] => {
  return curveCoordinates.reduce<[number, number][]>((acc, [spend, revenue]) => {
    // Avoid division by zero and invalid values
    if (spend === 0) return acc;

    const marginalYield = revenue / spend;

    // Only include valid, finite marginal yields
    if (isFinite(marginalYield)) {
      acc.push([spend, marginalYield]);
    }

    return acc;
  }, []);
};
